import AreaChartComponent from "./Area";
import PieChartComponent from "./Pie";

const Charts = () => {};

export const AreaChart = AreaChartComponent;
export const PieChart = PieChartComponent;

export default Charts;
